import UBreadcrumbs from "@/components/uikit/uComponents/UBreadcrumbs.vue";
import UButton from "@/components/uikit/uComponents/UButton.vue";
import UContent from "@/components/uikit/uLayouts/UContent.vue";
import UDecimal from "@/components/uikit/uComponents/UDecimal.vue";
import UIcon from "@/components/uikit/uComponents/UIcon.vue";
import UInput from "@/components/uikit/uComponents/UInput.vue";
import UList from "@/components/uikit/uComponents/UList.vue";
import UProgressBar from "@/components/uikit/uComponents/UProgressBar.vue";
import UText from "@/components/uikit/uComponents/UText.vue";
import UTextHeader from "@/components/uikit/uComponents/UTextHeader.vue";
import UTextSubHeader from "@/components/uikit/uComponents/UTextSubHeader.vue";
//Так же добавить в global-components.d.ts
const Components = {
    UButton,
    UIcon,
    UInput,
    UDecimal,
    UBreadcrumbs,
    UText,
    UContent,
    UProgressBar,
    UList,
    UTextHeader,
    UTextSubHeader
};
export default Components;
